import get from 'lodash/get';
import sortBy from 'lodash/sortBy';

import { numberToCurrency } from '../../utils/currency';

export function buildAccountName(locale, account) {
  const { balance, name, nickname, number } = account;
  return `${[nickname || name, number].filter(Boolean).join(' - ')} (${numberToCurrency(
    balance
  )} ${locale['common.available']})`;
}

export function buildBankCode(details) {
  const num = get(details, 'routingNumber') || get(details, 'bankCode');
  return {
    id: num,
    name: details && `${num} - ${details.bankName}`,
    paymentMethod: get(details, 'paymentMethod')
  };
}

export function buildBankCodes(codes) {
  return codes.map(buildBankCode);
}

export function buildAccountList(locale, accounts) {
  // sort accounts by name and number
  const sorted = sortBy(accounts, [
    (x) => x.nickname?.toLowerCase() || x.name.toLowerCase(),
    'number'
  ]);
  return sorted.map((account) => buildAccount(locale, account));
}

export function specialChars({ locale, paymentType, prefs }) {
  return (name, _param, values) => {
    if (!prefs?.mtsAllowedCharacters) return null;
    const allowedChars = prefs.mtsAllowedCharacters[paymentType];
    const value = String(values[name]);
    const isValid =
      allowedChars && value ? [...value].every((x) => [...allowedChars].includes(x)) : true;
    if (!isValid) return locale['common.invalidChars'];
    return null;
  };
}
